import React, { useEffect, useState } from 'react'
import * as Yup from "yup"
import { useFormik } from 'formik';
import clsx from 'clsx';
import { createTransaction, exchangeRate, fetchAccountUsage, getCurrencies, pendingTransactions } from '../../../utils/Api';
import { toast } from 'react-toastify';
import Bank_list from '../../../utils/Bank_list';
import { commaRemover, commaSeperator } from '../../../utils/hook';
import Select, { components } from "react-select"
import { useNavigate } from 'react-router';
import { Button, Modal } from 'react-bootstrap';
import { inputValidator } from '../../../hooks/validator';
import limits from '../../../hooks/limitations';


const AmountDetail = ({ handleStep, step, previous }) => {

    const [loader, setLoader] = useState(false)
    const [tier_data, setTierData] = useState({
        count: "N/A",
        limit: "N/A",
        is_unlimited: false
    })
    const [warning, setWarning] = useState({ toggle: false, message: "" })
    const navigate = useNavigate()
    const [maxAmount, setmaxAmount] = useState(30000) // Set default to 30,000
    const [exch_rate, setExchRate] = React.useState('1.0998');
    const [amt_detail, setAmtDetail] = useState({
        send_amt: "",
        exchange_amt: "",
        from_type: "AUD",
        to_type: "NGN",
        recieve_meth: "Bank Transfer",
    })

    const [curr_out, setCurrOut] = useState([]);
    const [curr_in, setCurrIn] = useState([]);
    const [defaultExchange, setDefaultExchange] = useState("")
    const [blur_off, setBlurOff] = useState(false);
    const [toCountry, setToCountry] = useState("Nigeria");

    const amtSchema = Yup.object().shape({
        send_amt: Yup.string("Please enter a valid amount").notOneOf([".", ""]).test("value-test", (value, validationcontext) => {
            const {
                createError,
            } = validationcontext;
            const numericValue = Number(commaRemover(value));
            if (numericValue < 100) {
                return createError({ message: "Minimum $100 required" })
            }
            if (numericValue > 30000) {
                return createError({ message: `Maximum transaction limit is $30,000` })
            }
            else {
                return true
            }
        }).required("Amount Send is required"),
        exchange_amt: Yup.string("Please enter a valid amount").notOneOf([".", ""]).required(),
        from_type: Yup.string().required(),
        to_type: Yup.string().required(),
    })

    const initialValues = {
        send_amt: "",
        exchange_amt: "",
        from_type: "AUD",
        to_type: "NGN",
        recieve_meth: "Bank Transfer",
    }

    const formik = useFormik({
        initialValues,
        validationSchema: amtSchema,
        validateOnChange: true,
        validateOnBlur: false,
        onSubmit: async (values) => {
            const cleaned = values.send_amt.replace(/,/g, "");
            const numericValue = Number(cleaned);
            if (numericValue > 30000) {
                toast.info(`Maximum transaction limit is $30,000`);
                return;
            }
            setLoader(true)
            let local = {}
            var transaction_id = sessionStorage.getItem("transaction_id") ? sessionStorage.getItem("transaction_id") : null
            const exch_data = await exchangeRate({ amount: values.send_amt, from: values.from_type, to: values.to_type, direction: "from" });
            let payload = {
                transaction_id: transaction_id,
                amount: {
                    send_amount: commaRemover(values.send_amt),
                    receive_amount: commaRemover(exch_data.amount),
                    send_currency: values.from_type,
                    receive_currency: values.to_type,
                    receive_method: "Bank transfer",
                    payout_partner: previous?.payout_part || "",
                    reason: previous ? previous.reason : "none",
                    exchange_rate: exch_rate
                }
            }
            if (transaction_id === null || transaction_id === "undefined" || transaction_id === "") {
                delete payload["transaction_id"]
            }
            let amt = values.send_amt.includes(".") ? values.send_amt : values.send_amt + ".00"
            const trans_res = await createTransaction(payload);
            setLoader(false);
            if (trans_res.code === "200") {
                sessionStorage.setItem("transaction_id", trans_res?.data.transaction_id)
                if (sessionStorage.getItem("transfer_data")) {
                    local = JSON.parse(sessionStorage.getItem("transfer_data"))
                }
                local.amount = { ...values, send_amt: commaRemover(amt), exchange_amt: commaRemover(exch_data.amount), exchange_rate: exch_rate, defaultExchange: defaultExchange }
                sessionStorage.setItem("transfer_data", JSON.stringify(local))
                if (sessionStorage.getItem("send-step")) {
                    sessionStorage.removeItem("send-step")
                }
                sessionStorage.setItem("send-step", Number(step) + 1)
                handleStep(Number(step) + 1)
            } else if (trans_res.code === "400") {
                toast.error(res.message, { autoClose: 2000, position: "bottom-right", hideProgressBar: true });
            }
        },
    })

    const myTotalAmount = (event, direction) => {
        event.preventDefault();
        if (event.target.value.length > 0) {
            setLoader(true)
            let value = commaRemover(event.target.value);
            if (Number(value) < 100 || Number(value) > 30000) {
                setLoader(false);
                console.log("coming in return");
                return;
            }
            exchangeRate({ amount: value, from: formik.values.from_type, to: formik.values.to_type, direction: direction })
                .then(function (response) {
                    let data = commaSeperator(response.amount)
                    if (direction === "From") {
                        formik.setFieldValue("exchange_amt", data)
                        formik.setFieldTouched("exchange_amt", true)
                        formik.setFieldError("exchange_amt", false)
                        formik.setFieldValue("send_amt", event.target.value.includes(".") ? event.target.value : event.target.value + ".00")
                        setAmtDetail({ ...amt_detail, exchange_amt: data, send_amt: event.target.value.includes(".") ? event.target.value : event.target.value + ".00" })
                        setDefaultExchange(response?.default_exchange)

                    } else {
                        formik.setFieldValue("send_amt", data.includes(".") ? data : data + ".00")
                        setAmtDetail({ ...amt_detail, send_amt: data.includes(".") ? data : data + ".00" })
                        formik.setFieldTouched("send_amt", true)
                        formik.setFieldError("send_amt", "")
                    }
                    setLoader(false)
                    setExchRate(response.rate)
                    setBlurOff(true)
                })
                .catch(function (error, message) {
                    setLoader(false)
                    setBlurOff(true)
                })
            formik.setErrors({ ...formik.errors, exchange_amt: false, send_amt: false })
        } else {
            formik.setFieldValue("exchange_amt", "")
            setAmtDetail({ ...amt_detail, exchange_amt: "" })
            setBlurOff(true)
        }
    }

    const inputvalidation = (event) => {
        var data = event.target.value;
        if (data.length > 0) {
            if (data.includes(',')) {
                let value = data.split(",")
                data = value.join("")
            }
            if (/^\d*\.?\d{0,2}$/.test(data)) {
                // Check if the numeric value exceeds 30,000
                const numericValue = parseFloat(data);
                if (numericValue > 30000) {
                    toast.info("Maximum transaction limit is $30,000", {
                        autoClose: 2000,
                        position: "bottom-right",
                        hideProgressBar: true
                    });
                    return; // Prevent updating the field
                }
                
                const [integerPart, decimalPart] = data.split('.')
                const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                if (decimalPart !== undefined) {
                    data = formattedIntegerPart + "." + decimalPart
                } else {
                    data = formattedIntegerPart
                }
                formik.setFieldValue(event.target.name, data);
                formik.setFieldTouched(event.target.name, true);
                setAmtDetail({ ...amt_detail, [event.target.name]: data });
                setBlurOff(false)
            } else {
                event.preventDefault();
            }
        } else {
            setAmtDetail({ ...amt_detail, send_amt: "", exchange_amt: "" })
            formik.setValues({ ...formik.values, send_amt: "", exchange_amt: "" })
        }
    }

    const amountDown = (e, direction) => {
        if (e.key === "Enter") {
            amountBlur(e, direction)
        }
    }
    const amountBlur = (e, direction) => {
        if (e.target.value !== "." && blur_off === false) {
            myTotalAmount(e, direction)
        }
    }

    const myTotalAmountFrom = (e) => {
        setAmtDetail({ ...amt_detail, from_type: e.target.value })
        formik.setFieldValue("from_type", e.target.value)
        formik.setFieldTouched("from_type", true)
        setLoader(true)
        const amt = commaRemover(formik.values.send_amt != undefined && formik.values.send_amt != 0 && formik.values.send_amt != "" ? formik.values.send_amt : "1")
        exchangeRate({ amount: amt, from: e.target.value, to: formik.values.to_type })
            .then(function (response) {
                setExchRate(response.rate)
                setDefaultExchange(response?.default_exchange)
                if (formik.values.send_amt != 0 && formik.values.send_amt != "" && formik.values.send_amt != undefined) {
                    formik.setFieldValue("exchange_amt", commaSeperator(response.amount))
                    setAmtDetail({ ...amt_detail, exchange_amt: commaSeperator(response.amount) })
                }
                setLoader(false)
                setBlurOff(true)

            })
            .catch(function (error, message) {
                setLoader(false)
                setBlurOff(true)

            })
    }

    const myTotalAmountTo = (e) => {
        setAmtDetail({ ...amt_detail, to_type: e.target.value })
        formik.setFieldValue("to_type", e.target.value)
        formik.setFieldTouched("to_type", true);
        setLoader(true)
        const amt = commaRemover(formik.values.send_amt != undefined && formik.values.send_amt != 0 && formik.values.send_amt != "" ? formik.values.send_amt : "1")

        exchangeRate({ amount: amt, from: formik.values.from_type, to: e.target.value })
            .then(function (response) {
                setExchRate(response.rate)
                setDefaultExchange(response?.default_exchange)
                if (formik.values.send_amt != 0 && formik.values.send_amt != undefined && formik.values.send_amt != "") {
                    formik.setFieldValue("exchange_amt", commaSeperator(response.amount))
                    setAmtDetail({ ...amt_detail, exchange_amt: commaSeperator(response.amount) })
                }
                setLoader(false)
                setBlurOff(true)

            })
            .catch(function (error, message) {
                setLoader(false)
                setBlurOff(true)

            })
    }
    const handleCancel = () => {
        sessionStorage.removeItem("transfer_data")
        sessionStorage.removeItem("send-step")
        navigate("/dashboard")
    }

    const handleRecieveMethod = (e) => {
        if (e.target.value === "Mobile Wallet") {
            toast.warn("THIS SERVICE OPTION IS CURRENTLY UNAVAILABLE", { hideProgressBar: true, autoClose: 500, position: "bottom-right" })
            setAmtDetail({ ...amt_detail, recieve_meth: "Bank Transfer" })
            formik.setFieldValue("recieve_meth", "Bank Transfer")
        } else {
            setAmtDetail({ ...amt_detail, recieve_meth: e.target.value })
            formik.setFieldValue("recieve_meth", e.target.value)
        }
    }

    const handlePayoutPart = (e, name) => {
        if (name === "services") {
            toast.warn("THIS SERVICE OPTION IS CURRENTLY UNAVAILABLE", { hideProgressBar: true, autoClose: 1000, position: "bottom-right" })
        }
    }


    useEffect(() => {

        fetchAccountUsage().then((res) => {
            if (res.code === "200") {
                setTierData({
                    count: res?.data?.transactions_left !== null ? res?.data?.transactions_left?.toString() : "N/A",
                    limit: res?.data?.amount_left !== null ? res?.data?.amount_left?.toString() : "N/A",
                    is_unlimited: res?.data?.unlimited
                })
            }
        })

        getCurrencies().then((res) => {
            if (res?.code === "200") {
                // Keep max at 30,000 regardless of API response
                const apiMax = res?.data?.max_send_amount.replace(/[^0-9]/g, "");
                setmaxAmount(Math.min(30000, Number(apiMax) || 30000));
                setCurrOut(() => {
                    return res?.data?.payout_currencies?.map((cr) => (
                        { label: cr.country, value: cr.currency }
                    ));
                })
                setCurrIn(() => {
                    return res?.data?.payin_currencies?.map((cr) => (
                        cr.currency
                    ));
                })
            }
        })
    }, [])

    useEffect(() => {
        if (previous !== null && !sessionStorage.getItem("transfer_data")) {
            exchangeRate({ amount: previous?.amount, from: previous?.send_currency, to: previous?.receive_currency, direction: "from" }).then(res => {
                setAmtDetail({
                    send_amt: commaSeperator(previous?.amount),
                    from_type: previous?.send_currency,
                    exchange_amt: commaSeperator(res?.amount),
                    to_type: previous?.receive_currency,
                    recieve_meth: previous?.recieve_meth || "Bank Transfer",
                })
                formik.setValues({
                    send_amt: commaSeperator(previous?.amount),
                    from_type: previous?.send_currency,
                    exchange_amt: commaSeperator(res?.amount),
                    to_type: previous?.receive_currency,
                    recieve_meth: previous?.recieve_meth || "Bank Transfer",
                })
                setExchRate(res?.rate)
                setDefaultExchange(res?.default_exchange)
            })
        }
        else if (sessionStorage.getItem("transfer_data")) {
            let tdata = JSON.parse(sessionStorage.getItem("transfer_data"))
            if (tdata?.amount) {
                setAmtDetail({
                    ...tdata?.amount,
                    send_amt: commaSeperator(tdata.amount.send_amt),
                    exchange_amt: commaSeperator(tdata.amount.exchange_amt),
                    recieve_meth: tdata?.amount?.recieve_meth || "Bank Transfer",
                })
                formik.setValues({
                    ...tdata?.amount,
                    send_amt: commaSeperator(tdata.amount.send_amt),
                    exchange_amt: commaSeperator(tdata.amount.exchange_amt),
                    recieve_meth: tdata?.amount?.recieve_meth || "Bank Transfer",
                })
                setExchRate(tdata?.amount?.exchange_rate)
                setDefaultExchange(tdata?.amount?.defaultExchange)
                if (curr_out.length > 0) {
                    const selected = curr_out.find((opt) => (opt.value === tdata?.amount?.to_type));
                    if (selected) {
                        setToCountry(selected.label)
                    }
                }
            }
        }
        else if (sessionStorage.getItem("conversion_data")) {
            let cdata = JSON.parse(sessionStorage.getItem("conversion_data"))

            if (cdata?.amount) {
                const amountData = {
                    send_amt: cdata.amount.send_amt ? commaSeperator(cdata.amount.send_amt.toString()) : "",
                    exchange_amt: cdata.amount.exchange_amt ? commaSeperator(cdata.amount.exchange_amt.toString()) : "",
                    from_type: cdata.amount.from_type,
                    to_type: cdata.amount.to_type,
                    recieve_meth: cdata.amount.recieve_meth || "Bank Transfer"
                };
                setAmtDetail(amountData);
                formik.setValues(amountData);
                setExchRate(cdata.amount.exchange_rate || "");
                setDefaultExchange(cdata.amount.defaultExchange || "");
                sessionStorage.setItem("transfer_data", JSON.stringify(cdata));

                if (curr_out.length > 0) {
                    const selected = curr_out.find((opt) => (opt.value === cdata.amount.to_type));
                    if (selected) {
                        setToCountry(selected.label);
                    }
                }
            }
        }
        else {
            let data = JSON.parse(sessionStorage.getItem("exchange_curr"))
            if (data) {
                setAmtDetail({
                    ...amt_detail,
                    send_amt: "",
                    exchange_amt: "",
                    from_type: data?.from_type,
                    to_type: data?.to_type
                })
                setExchRate(data?.exch_rate)
                formik.setValues({
                    ...formik.values,
                    send_amt: "",
                    exchange_amt: "",
                    from_type: data?.from_type,
                    to_type: data?.to_type
                })
                setDefaultExchange(data?.defaultExchange)
                if (curr_out.length > 0) {
                    const selected = curr_out.find((opt) => (opt.value === data.to_type));
                    if (selected) {
                        setToCountry(selected.label)
                    } else {
                        setToCountry(curr_out?.[0]?.label)
                    }
                }
            }
        }
    }, [previous, curr_out])

    const Placeholder = (props) => {
        return <components.Placeholder {...props} />;
    };

    useEffect(() => {
        if (formik.values.send_amt && formik.values.exchange_amt) {
            if (Number(commaRemover(formik.values.send_amt)) >= 100) {
                formik.setErrors({ ...formik.errors, exchange_amt: undefined, send_amt: undefined })
            } else {
                formik.setFieldError("send_amt", "Minimum $100 is required.")
            }
        }
        if (formik.values.to_type && curr_out.length > 0) {
            const selected = curr_out.find((opt) => (opt.value === formik.values.to_type));
            if (selected) {
                setToCountry(selected.label)
            }
        }
    }, [formik.values]);

    return (
        <>
            <section>
                <div className="form-head mb-4">
                    <h2 className="text-black font-w600 mb-0"><b>Amount & Delivery</b>
                    </h2>
                </div>
                <form noValidate autoComplete='off' className='pb-5'>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input_field rate-value">
                                        <p className="get-text Exchange_rate">Exchange Rate</p>
                                        <p className="exchange-rate exchange_value" >1 <span>{formik.values.from_type}</span> = {commaSeperator(exch_rate)} <span>{formik.values.to_type}</span> </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row each-row">
                                <div className="col-md-6">
                                    <div className="input_field">
                                        <p className="get-text">From<span style={{ color: 'red' }} >*</span></p>
                                        <select
                                            aria-label="Select a reason"
                                            onChange={(e) => { myTotalAmountFrom(e) }}
                                            value={formik.values.from_type}
                                            className='mb-3 bg-transparent form-control form-select rate_input '
                                        >
                                            {
                                                curr_in.map(item => (
                                                    <option value={item}>{item}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input_field">
                                        <p className="get-text">To<span style={{ color: 'red' }} >*</span></p>
                                        <select
                                            aria-label="Select a reason"
                                            className="mb-3 bg-transparent form-control form-select rate_input"
                                            onChange={(e) => { myTotalAmountTo(e) }}
                                            value={formik.values.to_type}
                                        >
                                            {
                                                curr_out.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.value}>{item.value}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row each-row">
                                <div className="col-md-6">
                                    <div className="input_field">
                                        <p className="get-text">Amount to Send<span style={{ color: 'red' }} >*</span></p>
                                        <input
                                            type="text"
                                            name="send_amt"
                                            value={formik.values?.send_amt}
                                            onKeyDown={(e) => amountDown(e, "From")}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                let clean = value.replace(/[^0-9]/g, "");
                                                inputvalidation(e);
                                            }}
                                            className={clsx(
                                                `mb-3 bg-transparent form-control rate-input ${formik.values.send_amt === "1" ? 'text-secondary lead' : ""}`,
                                                { 'is-invalid': formik.touched.send_amt && formik.errors.send_amt },
                                                {
                                                    'is-valid': formik.touched.send_amt && !formik.errors.send_amt,
                                                }
                                            )}
                                            onBlurCapture={(e) => amountBlur(e, "From")}
                                            placeholder='100'
                                        />
                                        {formik.touched.send_amt && formik.errors.send_amt && (
                                            <div className='fv-plugins-message-container mt-1'>
                                                <div className='fv-help-block'>
                                                    <span role='alert' className="text-danger" style={{ fontSize: "13px" }}>{formik.errors.send_amt}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input_field">
                                        <p className="get-text">
                                            Exchange Amount
                                        </p>
                                        <input
                                            type="text"
                                            name="exchange_amt"
                                            value={formik.values?.exchange_amt}
                                            onKeyDown={(e) => amountDown(e, "To")}
                                            onChange={(e) => inputvalidation(e)}
                                            className={clsx(
                                                `mb-3 bg-transparent form-control rate-input ${formik.values.send_amt === "1" ? 'text-secondary lead' : ""}`,
                                                { 'is-invalid': formik.touched.exchange_amt && formik.errors.exchange_amt },
                                                {
                                                    'is-valid': formik.touched.exchange_amt && !formik.errors.exchange_amt,
                                                }
                                            )}
                                            onBlurCapture={(e) => amountBlur(e, "To")}
                                            placeholder={defaultExchange !== "" && undefined ? commaSeperator(defaultExchange) : defaultExchange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row each-row">
                                <div className="col-md-12">
                                    <h5>Receive Method</h5>
                                    <div className="col-md-12" >
                                        <label className="container-new">
                                            <span className="radio-tick">Bank Transfer</span>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="recivedMethod"
                                                value="Bank Transfer"
                                                checked={amt_detail.recieve_meth == "Bank Transfer"}
                                                onChange={(e) => { handleRecieveMethod(e) }}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="container-new">
                                            <span className="radio-tick">Mobile Wallet <span className='small text-muted'>(coming soon)</span></span>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="recivedMethod"
                                                value="Mobile Wallet"
                                                checked={amt_detail.recieve_meth == "Mobile Wallet"}
                                                onChange={(e) => { handleRecieveMethod(e) }}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <button
                                        type='button'
                                        className="start-form-button full-col"
                                        onClick={() => handleCancel()}
                                    >Cancel</button>
                                </div>
                                <div className="col-md-8 full-col">
                                    <button
                                        type="button"
                                        onClick={() => formik.handleSubmit()}
                                        className="form-button full-col"
                                    >
                                        Continue
                                        {loader ? <>
                                            <div className="loader-overly">
                                                <div className="loader" >
                                                </div>
                                            </div>
                                        </> : ""}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form >

            </section>
            <WarningModal show={warning.toggle} content={warning.message} onHide={() => { setWarning({ toggle: false, message: "" }) }} />
        </>
    );
}


const WarningModal = ({ show, content, onHide }) => {

    const navigate = useNavigate()

    const submit = () => {
        navigate("/user-profile")
    }

    return (
        <>
            <Modal backdrop={"static"} show={show} centered onHide={onHide}>
                <Modal.Header closeButton>
                    Transaction limit exceed
                </Modal.Header>
                <Modal.Body className='mb-5 mt-3'>
                    <div>
                        {content}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="click" variant="primary" onClick={() => submit()}>
                        Upgrade
                    </Button>
                </Modal.Footer>

            </Modal>
        </>
    )
}

export default AmountDetail